import {DataTransferObjectValidation, Types} from "../../../../../type/Types";

export namespace PlaceSummaryFunnelStatsDataTransferObject {
    export type Post = {
        exposedAtList: string[]
    }

    export namespace Post {
        export const description: Record<keyof Post, string> = {
            exposedAtList: '노출일 목록'
        }

        export const validation: DataTransferObjectValidation<Post> = {
            exposedAtList(o: string): string[] | Error {
                if (o.length === 0) {
                    return []
                }

                const tokens = o.split(',')
                for (const token of tokens) {
                    const result = DataTransferObjectValidation.validateDate(token, 'exposedAtList')
                    if (result instanceof Error) {
                        return result
                    }
                }

                return tokens
            }
        }

        export function construct(o: any): Post {
            return {
                exposedAtList: o,
            }
        }
    }

    export type Date = {
        year: string
        day: string
        month: string
    }

    export namespace Date {
        export const description: Record<keyof Date, string> = {
            year: '년',
            day: '월',
            month: '일',
        }

        export const validation: DataTransferObjectValidation<Date> = {
            year(o: string): string | Error {
                if (o.length === 0) {
                    return ''
                }

                if(Number(o) <= 0)
                    return new Error('년도 형식이 맞지 않습니다.')

                return o
            },
            month(o: string): string | Error {
                if (o.length === 0) {
                    return ''
                }

                if(Number(o) > 12 || Number(o) <= 0)
                    return new Error('월 형식이 맞지 않습니다.')

                return o
            },
            day(o: string): string | Error {
                if (o.length === 0) {
                    return ''
                }

                if(Number(o) > 31 || Number(o) <= 0)
                    return new Error('일 형식이 맞지 않습니다.')

                return o
            },
        }
    }
}